"use client";

import EditMode24 from "@ui/icons/24x24/edit-mode-24.svg";
import { cn } from "@ui/lib/utils";
import { useTranslations } from "next-intl";

import { openSoundEffectEditor, toggleEditMode } from "../state/actions";
import { useSoundboard } from "../state/reducer";
import { SoundBoardButton } from "./SoundBoardButton";

export const EditModeButton = () => {
  const { dispatch, state } = useSoundboard();
  const t = useTranslations("ClientKeys.soundboard");

  const handleClick = () => {
    dispatch(toggleEditMode());
    if (!state.isInEditMode) {
      dispatch(openSoundEffectEditor(0, state));
    }
  };
  return (
    <SoundBoardButton className={cn("control-button", state.isInEditMode && "selected")} onClick={handleClick}>
      <EditMode24 />
      <p className='font-soundboard f-ui-04 w-full truncate text-inverse'>{t("edit_mode_button.label")}</p>
    </SoundBoardButton>
  );
};
